<template>
    <div class="view__tabs">
        <ul class="view__tabs--menu">
            <li :class="getCssClass('group')">
                <router-link :to="{ name: 'group', params}">
                    {{ L.localize('Label_Definition') }}
                </router-link>
            </li>
            <li :class="getCssClass('group-custom-fields')">
                <router-link :to="{ name: 'group-custom-fields', params}">
                    {{ L.localize('Label_CustomFields') }}
                </router-link>
            </li>
            <li :class="getCssClass('group-payment-options')">
                <router-link :to="{ name: 'group-payment-options', params}">
                    {{ L.localize('Label_PaymentOptions') }}
                </router-link>
            </li>
            <li :class="getCssClass('import')">
                <router-link :to="{ name: 'import'}">
                    {{ L.localize('Settings_Import_Export_Breadcrumb') }}
                </router-link>
            </li>
        </ul>

        <dropdown
          v-on:delete="deleteGroup"
          :label="actions.label"
          :links="actions.links"
          :isNotSync="true"
          acc="actions">
        </dropdown>
    </div>
</template>

<script>
import Dropdown from 'components/partials/Dropdown'
import L from 'services/Localization'
import { mapGetters } from 'vuex'
import notifications from 'mixins/notifications'

export default {
  name: 'Submenu',
  components: { Dropdown },
  mixins: [notifications],
  data() {
    return {
      L: L
    }
  },
  computed: {
    ...mapGetters({
      group: 'activeGroup'
    }),
    params() {
      let parameters = {}
      if (this.group) {
        parameters.params = { id: this.group.id }
      }
      return parameters
    },
    actions() {
      let menu = {
        label: L.localize('Label_Actions'),
        links: []
      }
      menu.links.push({
        label: L.localize('Settings_Group_Delete'),
        bypassRouter: true,
        asFunction: true,
        url: 'delete',
        acc: 'delete'
      })
      return menu
    }
  },
  methods: {
    getCssClass(name) {
      let baseClass = this.$route.name === name ? 'active' : ''
      return `view__tabs--tab ${baseClass}`
    },
    deleteGroup() {
      this.$store.dispatch('deleteGroup', this.$route.params.id).then(() => {
        this.showNotification({
          title: L.localize('Label_SuccessDeletion'),
          message: L.localize('Label_Success')
        })
        this.$router.push({name: 'groups'})
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// Submenu.vue?6306732e